import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgYoutubeSolid = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 25 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M2.667 3.667c0-.92.746-1.667 1.666-1.667H21c.92 0 1.667.746 1.667 1.667v16.666c0 .92-.747 1.667-1.667 1.667H4.333c-.92 0-1.666-.746-1.666-1.667z"
      />
      <path
        fill="#fff"
        d="M18.208 9.073a1.44 1.44 0 0 0-1.02-1.02c-.875-.22-4.594-.22-4.594-.22s-3.646 0-4.594.22c-.51.145-.875.51-1.02 1.02-.147.948-.147 2.844-.147 2.844s0 1.896.219 2.843c.146.51.51.875 1.02 1.021.876.219 4.595.219 4.595.219s3.646 0 4.593-.219c.51-.146.875-.51 1.021-1.02.219-.948.219-2.844.219-2.844s0-1.896-.292-2.844M11.5 13.667v-3.5l3.063 1.75z"
      />
    </svg>
  );
};
export default SvgYoutubeSolid;
